/* eslint-disable */

import {  lifecycleStates } from "./app/utils/constants";
const identifiers = 'DOR';
// data for change game
const changeGameDataMockup = {
  // currentLifecycleState: null,
  identifier: null,
  raceType: null,
  // lifecycleData: null,
  jackPot: 44440,
  superJackPot: 7878,
  isWebGameVersion: true, // data object returned from server
  walletAmount: 200,
  walletCurrency: "USD"
};

// data for event history
const eventsInHistoryId = {};
const startIdOfEvent = [6457, 7190, 8284, 9046];
Object.keys(identifiers).map((identifier, index) => {
  let eventIdsByIdentifier = [];
  let startEventId = startIdOfEvent[index];
  for (let i = 0; i < 8; i++) {
    eventIdsByIdentifier[i] = startEventId;
    startEventId++;
  }
  eventsInHistoryId[identifier] = eventIdsByIdentifier;
  return identifier;
});

// data for basket bet history
const eventsInBetBasketId = {};
const startIdOfBetEvent = [6327, 6790, 7284, 8046];
Object.keys(identifiers).map((identifier, index) => {
  let eventIdsByIdentifier = [];
  let startEventId = startIdOfBetEvent[index];
  for (let i = 0; i < 8; i++) {
    eventIdsByIdentifier[i] = startEventId;
    startEventId += 2;
  }
  eventsInBetBasketId[identifier] = eventIdsByIdentifier;
  return identifier;
});

// data for credits history
const operationsInCreditsNumber = {};
const startNumberOfCreditsOperation = [
  "234323-234323-23432",
  "121212-121212-12121",
  "321321-321321-32132",
  "656565-656565-65656"
];

Object.keys(identifiers).map((identifier, index) => {
  let operationNumbersByIdentifier = [];
  let startOperationNumber = startNumberOfCreditsOperation[index];
  for (let i = 0; i < 8; i++) {
    operationNumbersByIdentifier[i] = startOperationNumber;
    startOperationNumber += 2;
  }
  operationsInCreditsNumber[identifier] = operationNumbersByIdentifier;
  return identifier;
});

// data for withdraw history
const codesInWithdrawHistory = {};
const startNumberOfWithdrawCode = ["2343", "1212", "3213", "6565"];

Object.keys(identifiers).map((identifier, index) => {
  let withdrawCodesByIdentifier = [];
  let startWithdrawCode = startNumberOfWithdrawCode[index];
  for (let i = 0; i < 8; i++) {
    withdrawCodesByIdentifier[i] = startWithdrawCode;
    startWithdrawCode += 2;
  }
  codesInWithdrawHistory[identifier] = withdrawCodesByIdentifier;
  return identifier;
});

export const getEventHistoryData = identifier => {
  const eventHistoryByIdentifier = [];
  const now = Date.now();
  let past12minutes = now - 12 * 60 * 1000;
  const typeRaceArr = identifier.split("_");
  const lastItem = typeRaceArr[typeRaceArr.length - 1];

  eventsInHistoryId[identifier].map((eventId, index) => {
    if (index > lastItem) return false;
    const eventDate = new Date(past12minutes);
    eventHistoryByIdentifier[index] = {
      raceIndex: eventId,
      timeStartRace: `${eventDate.getHours()}:${eventDate.getMinutes()}`,
      first: index >= 4 ? 1 : 3 + index,
      second: index >= 4 ? 2 : 2 + index,
      third: index >= 4 ? 3 : 1 + index,
      winner: 6 + index,
      exacta: 23.1 + index,
      trifecta: 69.3 + index,
      quinella: 11 + index,
      placeInTwoFirst: 2.27 + index,
      placeInTwoSecond: 1.71 + index,
      placeOddsFirst: 1.9 + index,
      placeOddsSecond: 1.4 + index,
      placeOddsThird: 1.4 + index,
      oddWinner: 1.2 + index,
      overWinner: 2.68 + index
    };
    past12minutes = past12minutes + 2 * 60 * 1000;
    return eventId;
  });

  return eventHistoryByIdentifier;
};

export const getChangeGameData = identifier => {
  // console.log('identifier', identifier)
  const datacopy = { ...changeGameDataMockup };
  datacopy.identifier = identifier;
  const idntifierArr = identifier.split("_");
  datacopy.raceType = `${idntifierArr[idntifierArr.length - 2]}_${
    idntifierArr[idntifierArr.length - 1]
  }`;

  return datacopy;
};

// data for different state of lifecycle
const dataByLFState = {
  ["6"]: {
    [lifecycleStates.BET]: {
      state: "BET",
      identifier: "RACINGBET_MULTI_PORTAL_DOG_6",
      raceType: "DOG_6",
      broadcastType: "LIFECYCLE_STATUS",
      events: [
        {
          status: "BET",
          raceNumber: "0006",
          betTime: "180000",
          raceUUID: "000111",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        },
        {
          status: "BET",
          raceNumber: "0007",
          betTime: "240000",
          raceUUID: "000222",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        }
      ]
    },
    [lifecycleStates.BET_LOCKED]: {
      state: "BET_LOCKED",
      identifier: "RACINGBET_MULTI_PORTAL_DOG_6",
      raceType: "DOG_6",
      videoName: "rb6d_164",
      broadcastType: "LIFECYCLE_STATUS",
      events: [
        {
          status: "BET_LOCKED",
          raceNumber: "0006",
          betTime: "0",
          raceUUID: "000111",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        },
        {
          status: "BET",
          raceNumber: "0007",
          betTime: "180000",
          raceUUID: "000222",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        }
      ]
    },
    [lifecycleStates.RACE]: {
      state: "RACE",
      identifier: "RACINGBET_MULTI_PORTAL_DOG_6",
      raceType: "DOG_6",
      result: {
        raceIndex: 8150,
        first: 6,
        second: 1,
        third: 3,
        winner: 3.8,
        exacta: 18.4,
        trifecta: 55.2,
        quinella: 9.58,
        placeOddsFirst: 1.4,
        placeOddsSecond: 1.7,
        placeOddsThird: 1.7
      },
      broadcastType: "LIFECYCLE_STATUS",
      events: [
        {
          status: "RACE",
          raceNumber: "0005",
          betTime: "0",
          raceUUID: "000000",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        },
        {
          status: "BET_LOCKED",
          raceNumber: "0006",
          betTime: "0",
          raceUUID: "000111",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        },
        {
          status: "BET",
          raceNumber: "0007",
          betTime: "180000",
          raceUUID: "000222",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        },
        {
          status: "BET",
          raceNumber: "0008",
          betTime: "360000",
          raceUUID: "000333",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        }
      ]
    },
    [lifecycleStates.DELAY]: {
      state: "DELAY",
      identifier: "RACINGBET_MULTI_PORTAL_DOG_6",
      nextRaceNumber: "8151",
      result: {
        raceIndex: 8150,
        first: 6,
        second: 1,
        third: 3,
        winner: 3.8,
        exacta: 18.4,
        trifecta: 55.2,
        quinella: 9.58,
        placeOddsFirst: 1.4,
        placeOddsSecond: 1.7,
        placeOddsThird: 1.7
      },
      raceType: "DOG_6",
      broadcastType: "LIFECYCLE_STATUS"
    }
  },
  ["8"]: {
    [lifecycleStates.BET]: {
      state: "BET",
      identifier: "RACINGBET_MULTI_PORTAL_DOG_8",
      raceType: "DOG_8",
      broadcastType: "LIFECYCLE_STATUS",
      events: [
        {
          status: "BET",
          raceNumber: "88888",
          betTime: "180000",
          raceUUID: "000888",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3, 134.1, 55.2],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5, 129.4, 53.3],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7, 68.5, 28.2],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8, 87.6, 36.1],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5, 84, 34.6],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8, 60.4, 24.9],
            [137.3, 132.9, 76, 93.9, 90.5, 68.5, 12.9, 75.2],
            [50.8, 49.2, 28.1, 34.8, 33.5, 25.3, 67.6, 5.3]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37],
            [67.91, 65.6, 36.09, 45.36, 43.61, 32.13],
            [26.51, 25.62, 14.12, 17.73, 17.05, 12.58, 35.65]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7, 3.9, 1.8],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        },
        {
          status: "BET",
          raceNumber: "99999",
          betTime: "240000",
          raceUUID: "000889",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3, 134.1, 55.2],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5, 129.4, 53.3],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7, 68.5, 28.2],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8, 87.6, 36.1],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5, 84, 34.6],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8, 60.4, 24.9],
            [137.3, 132.9, 76, 93.9, 90.5, 68.5, 12.9, 75.2],
            [50.8, 49.2, 28.1, 34.8, 33.5, 25.3, 67.6, 5.3]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37],
            [67.91, 65.6, 36.09, 45.36, 43.61, 32.13],
            [26.51, 25.62, 14.12, 17.73, 17.05, 12.58, 35.65]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7, 3.9, 1.8],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        }
      ]
    },
    [lifecycleStates.BET_LOCKED]: {
      state: "BET_LOCKED",
      identifier: "RACINGBET_MULTI_PORTAL_DOG_8",
      raceType: "DOG_8",
      videoName: "rb6d_164",
      broadcastType: "LIFECYCLE_STATUS",
      events: [
        {
          status: "BET_LOCKED",
          raceNumber: "88888",
          betTime: "0",
          raceUUID: "000888",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3, 134.1, 55.2],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5, 129.4, 53.3],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7, 68.5, 28.2],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8, 87.6, 36.1],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5, 84, 34.6],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8, 60.4, 24.9],
            [137.3, 132.9, 76, 93.9, 90.5, 68.5, 12.9, 75.2],
            [50.8, 49.2, 28.1, 34.8, 33.5, 25.3, 67.6, 5.3]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37],
            [67.91, 65.6, 36.09, 45.36, 43.61, 32.13],
            [26.51, 25.62, 14.12, 17.73, 17.05, 12.58, 35.65]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7, 3.9, 1.8],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        },
        {
          status: "BET",
          raceNumber: "99999",
          betTime: 180000,
          raceUUID: "000889",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3, 134.1, 55.2],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5, 129.4, 53.3],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7, 68.5, 28.2],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8, 87.6, 36.1],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5, 84, 34.6],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8, 60.4, 24.9],
            [137.3, 132.9, 76, 93.9, 90.5, 68.5, 12.9, 75.2],
            [50.8, 49.2, 28.1, 34.8, 33.5, 25.3, 67.6, 5.3]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37],
            [67.91, 65.6, 36.09, 45.36, 43.61, 32.13],
            [26.51, 25.62, 14.12, 17.73, 17.05, 12.58, 35.65]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7, 3.9, 1.8],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        }
      ]
    },
    [lifecycleStates.RACE]: {
      state: "RACE",
      identifier: "RACINGBET_MULTI_PORTAL_DOG_8",
      raceType: "DOG_8",
      result: {
        raceIndex: 8150,
        first: 6,
        second: 1,
        third: 3,
        winner: 3.8,
        exacta: 18.4,
        trifecta: 55.2,
        quinella: 9.58,
        placeOddsFirst: 1.4,
        placeOddsSecond: 1.7,
        placeOddsThird: 1.7
      },
      broadcastType: "LIFECYCLE_STATUS",
      events: [
        {
          status: "RACE",
          raceNumber: "88888",
          betTime: "0",
          raceUUID: "000888",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3, 134.1, 55.2],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5, 129.4, 53.3],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7, 68.5, 28.2],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8, 87.6, 36.1],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5, 84, 34.6],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8, 60.4, 24.9],
            [137.3, 132.9, 76, 93.9, 90.5, 68.5, 12.9, 75.2],
            [50.8, 49.2, 28.1, 34.8, 33.5, 25.3, 67.6, 5.3]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37],
            [67.91, 65.6, 36.09, 45.36, 43.61, 32.13],
            [26.51, 25.62, 14.12, 17.73, 17.05, 12.58, 35.65]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7, 3.9, 1.8],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        },
        {
          status: "BET",
          raceNumber: "99999",
          betTime: "180000",
          raceUUID: "000889",
          combinedOdds: [
            [9.7, 97.6, 55.8, 68.9, 66.5, 50.3, 134.1, 55.2],
            [97.3, 9.4, 53.9, 66.5, 64.1, 48.5, 129.4, 53.3],
            [51.5, 49.8, 5.4, 35.2, 33.9, 25.7, 68.5, 28.2],
            [65.9, 63.8, 36.5, 6.6, 43.4, 32.8, 87.6, 36.1],
            [63.1, 61.1, 35, 43.2, 6.4, 31.5, 84, 34.6],
            [45.4, 44, 25.1, 31.1, 29.9, 4.8, 60.4, 24.9],
            [137.3, 132.9, 76, 93.9, 90.5, 68.5, 12.9, 75.2],
            [50.8, 49.2, 28.1, 34.8, 33.5, 25.3, 67.6, 5.3]
          ],
          quinellaOdds: [
            [],
            [48.77],
            [26.84, 25.93],
            [33.73, 32.58, 17.95],
            [32.43, 31.33, 17.26, 21.68],
            [23.9, 23.09, 12.73, 15.99, 15.37],
            [67.91, 65.6, 36.09, 45.36, 43.61, 32.13],
            [26.51, 25.62, 14.12, 17.73, 17.05, 12.58, 35.65]
          ],
          placeOdds: [3, 2.9, 1.8, 2.2, 2.1, 1.7, 3.9, 1.8],
          oddOdds: 1.9,
          evenOdds: 1.5,
          highOdds: 1.8,
          lowOdds: 1.6,
          multiplier: 3,
          vod: true
        }
      ]
    },
    [lifecycleStates.DELAY]: {
      state: "DELAY",
      identifier: "RACINGBET_MULTI_PORTAL_DOG_8",
      nextRaceNumber: "8151",
      result: {
        raceIndex: 8150,
        first: 6,
        second: 1,
        third: 3,
        winner: 3.8,
        exacta: 18.4,
        trifecta: 55.2,
        quinella: 9.58,
        placeOddsFirst: 1.4,
        placeOddsSecond: 1.7,
        placeOddsThird: 1.7
      },
      raceType: "DOG_8",
      broadcastType: "LIFECYCLE_STATUS"
    }
  }
};
export const getCurrentLifecycleData = (lifecycleStates, raceType) => {
  return raceType
    ? dataByLFState[raceType.split("_")[1]][lifecycleStates]
    : dataByLFState["6"][lifecycleStates];
};

export const getCurrentBasketData = () => {
  const currentBasketDataByIdentifier = {
    content: [
      {
        additionalInformation: "",
        betInformation: [
          {
            id: 16096,
            odds: 92.44,
            stake: 10,
            state: "LOSING",
            tax: 0,
            tip: "{i18n(ticket.tip.rb_TRIFECTA)} (1,2,3)-//-",
            win: 924.4,
            winning: false
          }
        ],
        expireDate: 1608733881913,
        gameName: "LUCKY SIX",
        gameNumber: "9383",
        issueDate: 1600957881913,
        jackpotCode: null,
        novice: false,
        shopInfo: "Test shop",
        state: "LOSING",
        ticketId: 14411,
        ticketNumber: "16806578996817588009",
        totalStake: 10,
        userId: 93,
        winning: false
      },
      {
        additionalInformation: "",
        betInformation: [
          {
            id: 16095,
            odds: 6.84,
            stake: 10,
            state: "LOSING",
            tax: 0,
            tip: "{i18n(ticket.tip.rb_FIRST)} (1)-//-",
            win: 68.4,
            winning: false
          }
        ],
        expireDate: 1608733875813,
        gameName: "LUCKY SIX",
        gameNumber: "9383",
        issueDate: 1600957875813,
        jackpotCode: null,
        novice: false,
        shopInfo: "Test shop",
        state: "LOSING",
        ticketId: 14410,
        ticketNumber: "16010578973756945009",
        totalStake: 10,
        userId: 93,
        winning: false
      }
    ],
    empty: false,
    first: true,
    last: true,
    number: 0,
    numberOfElements: 2,
    pageable: {
      offset: 0,
      pageNumber: 0,
      pageSize: 20,
      paged: true,
      sort: {
        empty: false,
        sorted: true,
        unsorted: false
      },
      unpaged: false
    },
    size: 20,
    sort: {
      empty: false,
      sorted: true,
      unsorted: false
    }
  };
  return currentBasketDataByIdentifier;
};

export const getCurrentCreditsData = identifier => {
  const currentCreditsDataByIdentifier = [];
  const now = Date.now();
  let past1hour = now - 240 * 60 * 1000;
  // const typeRaceArr = identifier.split("_");
  const lastItem = identifier;

  operationsInCreditsNumber[identifier].map((operationNumber, index) => {
    if (index > lastItem) return false;
    const operationDate = new Date(past1hour);
    currentCreditsDataByIdentifier[index] = {
      identifier: "RACINGBET_MULTI_PORTAL_DOG_6",
      raceType: "DOG_6",
      payIn: false,
      operationDate: `${operationDate.getDay()}/${operationDate.getMonth()}/${operationDate.getFullYear()}`,
      creditsBefore: 1030.5,
      amount: 250.0,
      credits: 780.5,
      operationNumber: operationNumber,
      cashierNumber: "ABDF-3254-3432",
      time: `${operationDate.getHours()}:${operationDate.getMinutes()}`,
      shop: "Shop Africa North",
      address: "Terrace Street 100",
      postalCode: 39070,
      city: "Lagos"
    };
    past1hour = past1hour + 60 * 60 * 1000;
  });

  return currentCreditsDataByIdentifier;
};

export const getCurrentWithdrawData = identifier => {
  const currentWithdrawDataByIdentifier = [];
  const now = Date.now();
  let past1hour = now - 240 * 60 * 1000;
  const typeRaceArr = identifier.split("_");
  const lastItem = typeRaceArr[typeRaceArr.length - 1];

  codesInWithdrawHistory[identifier].map((withdrawCode, index) => {
    if (index > lastItem) return false;
    const withdrawDate = new Date(past1hour);
    currentWithdrawDataByIdentifier[index] = {
      identifier: "RACINGBET_MULTI_PORTAL_DOG_6",
      raceType: "DOG_6",
      status: "Active",
      withdrawDate: `${withdrawDate.getDay()}/${withdrawDate.getMonth()}/${withdrawDate.getFullYear()}`,
      amount: 200.0,
      withdrawCode: withdrawCode,
      time: `${withdrawDate.getHours()}:${withdrawDate.getMinutes()}`
    };
    past1hour = past1hour + 60 * 60 * 1000;
  });

  return currentWithdrawDataByIdentifier;
};
